import { render, staticRenderFns } from "./examInformation.vue?vue&type=template&id=a6b1ba20&scoped=true"
import script from "./examInformation.vue?vue&type=script&lang=js"
export * from "./examInformation.vue?vue&type=script&lang=js"
import style0 from "./examInformation.vue?vue&type=style&index=0&id=a6b1ba20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b1ba20",
  null
  
)

export default component.exports